import { getProjectKeyOrIdFromMatchAndQuery } from '@jira/router-resources__utils/src/getProjectKeyOrId.tsx';
import type { ServiceDeskContextData } from '@atlassian/jira-navigation-types/src/types.tsx';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_SERVICEDESK_CONTEXT } from './resourceTypeServicedeskContext.constants.tsx';

export const serviceDeskContextResource: RouteResource<ServiceDeskContextData> =
	createResource<ServiceDeskContextData>({
		type: RESOURCE_TYPE_SERVICEDESK_CONTEXT,
		getKey: ({ match, query }) => getProjectKeyOrIdFromMatchAndQuery({ match, query }),
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-servicedesk-context", jiraSpaEntry: "async-resource-servicedesk-context" */ './getData.tsx'
			),
		maxAge: Infinity,
	});
